import React, { useState, useEffect } from 'react';
import cacheManager from '../CacheManager';
import { formatDate, formatTime } from '../js/dateFormatter';

const PgMeusAgendamentos = () => {
  const [agendamentos, setAgendamentos] = useState([]);
  const [itensByIdCache, setItensByIdCache] = useState({});
  const [espacosByIdCache, setEspacosByIdCache] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [filtro, setFiltro] = useState('todos'); // todos, futuros, passados

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setIsLoading(true);

      const itensById = await cacheManager.getItensById();
      setItensByIdCache(itensById);

      const espacosById = await cacheManager.getEspacosById();
      setEspacosByIdCache(espacosById);

      const agendamentosCache = await cacheManager.getAgendamentosCache();
      // Garantir que agendamentosCache é um array
      setAgendamentos(Array.isArray(agendamentosCache) ? agendamentosCache : []);

    } catch (error) {
      console.error('Erro ao carregar agendamentos:', error);
      setAgendamentos([]); // Definir como array vazio em caso de erro
    } finally {
      setIsLoading(false);
    }
  };

  const getAgendamentosFiltrados = () => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    // Garantir que agendamentos é um array antes de usar spread operator
    let filtrados = Array.isArray(agendamentos) ? [...agendamentos] : [];

    if (filtro === 'futuros') {
      filtrados = filtrados.filter(ag => new Date(ag.data_inicio_agendamento) >= hoje);
    } else if (filtro === 'passados') {
      filtrados = filtrados.filter(ag => new Date(ag.data_inicio_agendamento) < hoje);
    }

    return filtrados.sort((a, b) => new Date(b.data_inicio_agendamento) - new Date(a.data_inicio_agendamento));
  };

  const getStatusBadge = (dataInicio) => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const dataAgendamento = new Date(dataInicio);
    dataAgendamento.setHours(0, 0, 0, 0);

    if (dataAgendamento > hoje) {
      return <span className="badge bg-success">Futuro</span>;
    } else if (dataAgendamento.getTime() === hoje.getTime()) {
      return <span className="badge bg-warning text-dark">Hoje</span>;
    } else {
      return <span className="badge bg-secondary">Concluído</span>;
    }
  };

  if (isLoading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
      </div>
    );
  }

  const agendamentosFiltrados = getAgendamentosFiltrados();

  return (
    <div className="container mt-4">
      <div className="row mb-4">
        <div className="col-12">
          <h2>Meus Agendamentos</h2>
          <p className="text-muted">Visualize todos os seus agendamentos</p>
        </div>
      </div>

      {/* Filtros */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="btn-group" role="group">
            <button
              type="button"
              className={`btn ${filtro === 'todos' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFiltro('todos')}
            >
              Todos ({agendamentos.length})
            </button>
            <button
              type="button"
              className={`btn ${filtro === 'futuros' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFiltro('futuros')}
            >
              Futuros
            </button>
            <button
              type="button"
              className={`btn ${filtro === 'passados' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFiltro('passados')}
            >
              Passados
            </button>
          </div>
        </div>
      </div>

      {/* Lista de Agendamentos */}
      <div className="row">
        <div className="col-12">
          {agendamentosFiltrados.length === 0 ? (
            <div className="card border-0 shadow-sm">
              <div className="card-body text-center py-5">
                <i className="bi bi-calendar-x fs-1 text-muted mb-3"></i>
                <p className="text-muted">Nenhum agendamento encontrado para este filtro.</p>
              </div>
            </div>
          ) : (
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Item/Serviço</th>
                        <th>Espaço</th>
                        <th>Data</th>
                        <th>Horário Início</th>
                        <th>Horário Fim</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {agendamentosFiltrados.map((agendamento, index) => (
                        <tr key={index}>
                          <td className="fw-bold">
                            {itensByIdCache[agendamento.id_item]?.titulo || 'Item não encontrado'}
                          </td>
                          <td>
                            {espacosByIdCache[agendamento.id_espaco]?.nome || 'Espaço não definido'}
                          </td>
                          <td>{formatDate(agendamento.data_inicio_agendamento)}</td>
                          <td>{formatTime(agendamento.data_inicio_agendamento)}</td>
                          <td>{formatTime(agendamento.data_fim_agendamento)}</td>
                          <td>{getStatusBadge(agendamento.data_inicio_agendamento)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PgMeusAgendamentos;
